"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicTenant = exports.getPublicTenants = exports.putTenantAccessibility = exports.deleteTenantPermission = exports.postTenantPermission = exports.postTenant = exports.putTenant = exports.getTenants = exports.getTenant = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var tenantsAuthorizedPath = root_1.identityAuthorized + '/tenants/';
var tenantsPublicPath = root_1.identityPublic + '/tenants/';

var getTenant = function getTenant(authentication, id) {
  return common_1.get(authentication, tenantsAuthorizedPath + (id || authentication.tenantId));
};

exports.getTenant = getTenant;

var getTenants = function getTenants(authentication, queryParameters) {
  return common_1.get(authentication, tenantsAuthorizedPath, queryParameters);
};

exports.getTenants = getTenants;

var putTenant = function putTenant(authentication, tenant) {
  return common_1.put(authentication, tenantsAuthorizedPath + tenant.id, tenant);
};

exports.putTenant = putTenant;

var postTenant = function postTenant(authentication, tenant) {
  return common_1.post(authentication, tenantsAuthorizedPath, tenant);
};

exports.postTenant = postTenant;

var postTenantPermission = function postTenantPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, tenantsAuthorizedPath, id, permission);
};

exports.postTenantPermission = postTenantPermission;

var deleteTenantPermission = function deleteTenantPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, tenantsAuthorizedPath, id, permissionId);
};

exports.deleteTenantPermission = deleteTenantPermission;

var putTenantAccessibility = function putTenantAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, tenantsAuthorizedPath, id, accessibility);
};

exports.putTenantAccessibility = putTenantAccessibility;

var getPublicTenants = function getPublicTenants(authentication, queryParameters) {
  return common_1.get(authentication, tenantsPublicPath, queryParameters);
};

exports.getPublicTenants = getPublicTenants;

var getPublicTenant = function getPublicTenant(authentication, tenantId) {
  return common_1.get(authentication, tenantsPublicPath + tenantId);
};

exports.getPublicTenant = getPublicTenant;